<template>
  <Modal class="confirm-modal" data-cy="confirm-modal" @close="close">
    <div class="confirm-modal__dialog">
      <h3 class="mb-5">Bạn có chắc là bạn muốn xóa?</h3>

      <div class="confirm-modal__button-container">
        <button
          class="confirm-modal__button confirm-modal__button--confirm"
          data-cy="confirm-button"
          @click="$emit('click')"
        >
          Tôi muốn xóa
        </button>
        <button
          class="confirm-modal__button confirm-modal__button--cancel"
          @click="close"
        >
          Thoát
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  name: "ConfirmModal",

  inheritAttrs: false,

  components: {
    Modal
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-modal {
  background: rgba(0, 0, 0, 0.5);
}

.confirm-modal__dialog {
  box-sizing: border-box;
  padding: 0.7rem;
  width: 260px;
  border-radius: 5px;
  background: #fff;
  color: #000;
}

.confirm-modal__button-container {
  display: flex;
  justify-content: space-between;
}

.confirm-modal__button {
  border: none;
  text-transform: uppercase;
  font-size: 1rem;

  &--confirm {
    background: none;
    color: red;
  }

  &--cancel {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background: black;
    color: white;
  }
}
</style>
